import { render, staticRenderFns } from "./InstalikePin.vue?vue&type=template&id=01d7c076&"
import script from "./InstalikePin.vue?vue&type=script&lang=ts&"
export * from "./InstalikePin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports